import { Controller } from '@hotwired/stimulus'
import DateRangePicker from 'flowbite-datepicker/DateRangePicker'
import no from '../../../../node_modules/flowbite-datepicker/js/i18n/locales/no.js'
import { format } from 'date-fns'

export default class extends Controller {
  static targets = ['datepicker']
  static values = { startDate: String, endDate: String, options: String }

  initialize() {
    // rangepicker configuration
    this.rangepicker = new DateRangePicker(this.element, {
      inputs: this.datepickerTargets,
      ...JSON.parse(this.optionsValue)
    })

    // Must be in English because of date parsing
    // datepickers configuration
    //this.rangepicker.datepickers.forEach(datepicker => {
    //datepicker.config.locale = no.no; // changes language in input field (but not the picker)
    //});

    if (this.startDateValue && this.endDateValue) {
      const rangeStart = format(this.startDateValue, this.dateFormat)
      const rangeEnd = format(this.endDateValue, this.dateFormat)
      this.setDates(rangeStart, rangeEnd)
    }
  }

  connect() {
    this.rangepicker.element.addEventListener(
      'dateinput',
      this.handleDateInputEvent
    )
    this.rangepicker.datepickers[0].picker.element.addEventListener(
      'click',
      (event) => this.handleStartDateClick(event)
    )
    this.rangepicker.datepickers[1].picker.element.addEventListener(
      'click',
      (event) => this.handleEndDateClick(event)
    )
  }

  handleDateInputEvent() {
    this.rangepicker.datepickers.forEach((datepicker) => datepicker.update())
  }

  handleStartDateClick(event) {
    // If user has clicked on a date
    if (event.target.dataset.date) this.onStartDateClick()
  }

  handleEndDateClick(event) {
    // If user has clicked on a date
    if (event.target.dataset.date) this.onEndDateClick()
  }

  // To be overwritten by other controllers with an outlet
  onStartDateClick() {}
  onEndDateClick() {}

  setDates(rangeStart, rangeEnd) {
    this.rangepicker.setDates(rangeStart, rangeEnd)
  }

  get selectedDates() {
    return this.rangepicker.getDates()
  }

  get dateFormat() {
    return this.rangepicker.datepickers[0].config.format
  }
}
